import React, {useEffect, useState} from 'react';

import LinkButton from '../link-button';

import {
  Container,
  Title,
  Reload,
  Description,
  Spacer,
  Loader,
  BackIconContainer,
} from './styles';
import {UseInfiniteQueryResult} from 'react-query';
import dateFnsService from 'shared/services/date-fns-service';
import Button from '../button';
import {FaArrowLeft} from 'react-icons/fa';
import {useNavigate} from 'react-router-dom';
import useAccessControls from 'modules/access-controls/atoms/use-access-controls';

export interface ActionButtonProps {
  title: string;
  to?: string;
  onClick?: () => void;
  loading?: boolean;
  permissions?: string[];
}

export interface TitleBarProps {
  title: string;
  actionButton?: ActionButtonProps;
  inifityQuery?: UseInfiniteQueryResult;
  backUrl?: string;
}

const TitleBar: React.FC<TitleBarProps> = ({
  title,
  actionButton,
  inifityQuery,
  backUrl,
}) => {
  const [date, setDate] = useState<Date | undefined>();
  const {isPermissionsAllowed} = useAccessControls();
  const navigate = useNavigate();

  useEffect(() => {
    if (!inifityQuery?.isFetching) setDate(new Date());
    else setDate(undefined);
  }, [inifityQuery]);

  return (
    <Container>
      {backUrl && (
        <BackIconContainer onClick={() => navigate(backUrl)}>
          <FaArrowLeft size={20} />
        </BackIconContainer>
      )}
      <Title>{title}</Title>
      {inifityQuery && !inifityQuery.isFetching && (
        // @ts-ignore
        <Reload onClick={inifityQuery.refetch} />
      )}
      {inifityQuery && inifityQuery.isFetching && <Loader />}
      {inifityQuery && (
        <Description>
          {!inifityQuery.isFetching &&
            date &&
            dateFnsService.formatDistanceFromNow(date)}
          {inifityQuery.isFetching && 'carregando dados...'}
        </Description>
      )}
      <Spacer />
      {actionButton && isPermissionsAllowed(actionButton.permissions) && (
        <>
          {actionButton.to && (
            <LinkButton
              title={actionButton.title}
              to={actionButton.to}
              size="small"
            />
          )}
          {actionButton.onClick && (
            <Button
              title={actionButton.title}
              onClick={actionButton.onClick}
              loading={actionButton.loading}
              size="small"
            />
          )}
        </>
      )}
    </Container>
  );
};

export default TitleBar;
